import React, {Component} from 'react'
import {connect} from 'react-redux';

import GuestBookCommentListHeader from '../../components/comments/guestBookComment/GuestBookCommentListHeader'
import GuestBookCommentList from '../../components/comments/guestBookComment/GuestBookCommentList'
import Pagination from '../../components/common/Pagination';
import ListTitle from "../../components/common/list/ListTitle";
import {parseListParams} from '../../components/common/CommentListHelper';
import GuestBookCommentPopupLayer from "./GuestBookCommentPopupLayer";
import * as InitStatus from "../../constants/common/InitializationStatus";
import autobind from "autobind-decorator";

@connect(state => ({
  items: state.guestbookComment.item.items,
  totalCount: state.guestbookComment.item.totalCount,
  searchKeyword: state.guestbookComment.condition.searchKeyword,
}))
class GuestBookCommentApp extends Component {

  constructor(props) {
    super(props);
    this.state = {headerStatus: InitStatus.INIT_READY}
  }

  // Header process 상태
  @autobind
  handleSetHeaderStatus(status) {
    this.setState({headerStatus: status});
  }

  render() {
    const {totalCount, searchKeyword} = this.props;
    return (
      <div className="inner_article reply_article">
        <h2 id="kakaoBody" className="screen_out">티스토리 관리센터 본문</h2>
        <ListTitle headTitle="방명록 관리" totalCount={totalCount} searchKeyword={searchKeyword}/>
        <GuestBookCommentListHeader/>
        <GuestBookCommentList/>
        <Pagination totalCount={totalCount} parseListParams={parseListParams}/>
        <GuestBookCommentPopupLayer/>
      </div>
    )
  }
}

export default GuestBookCommentApp;
